














import Vue from 'vue';
import AppTabs from '@/components/layout/AppTabs.vue';
import AppTitle from '@/components/common/AppTitle/AppTitle.vue';
import { mapActions } from 'vuex';

export default Vue.extend({
  name: 'AppHeader',
  components: {
    AppTabs,
    AppTitle,
  },

  methods: {
    ...mapActions('global', ['toggleDrawer']),
  },
});
